import axios from 'axios'
import router from '../router'
import baseURl from './base'
import { nextTick } from 'vue'

import { getUserTicketApi, getTicketApi } from '@/utils/user.js'
const wx = require('weixin-js-sdk')
import { getAppIdStorage, setAppIdStorage, getStorage } from '@/libs/storage'
import { Toast } from 'vant'
axios.defaults.baseURL = baseURl

// 请求拦截
axios.interceptors.request.use(
  (config) => {
    //移动积分兑换url处理
    // if (config.url.indexOf('/ziyuan') === 0 && process.env.NODE_ENV !== 'development') {
    //     config.url = config.url.replace(/^\/ziyuan/, '')
    //     config.baseURL = 'https://api.imedicalmall.com/'
    // }

    if (
      config.url.includes('ziyuan') ||
      config.url.includes('meituwl') ||
      config.url.includes('/mapjson/map')
    ) {
      config.baseURL = ''
    }
    //设置请求头
    if (config.method === 'get') {
      //给data赋值以绕过axios判断（data存在，默认是post请求），get请求不允许设置请求头
      config.data = true
    }
    config.headers['Content-Type'] = 'application/json;charset=UTF-8;'

    if (config.url === '/hm/user/upload_avatar') {
      //头像上传
      config.headers['Content-Type'] =
        'multipart/form-data; boundary=----WebKitFormBoundaryURkv9Plmn0Tl5W2D'
      console.log('config.headers', config.headers)
    }

    let appId = localStorage.getItem('appId') || 'wx9a373b1354d442cf'
    if (getAppIdStorage(appId)) {
      config.headers.ticket = getAppIdStorage(appId).Ticket || ''
    }
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

//响应拦截

axios.interceptors.response.use(
  async (response) => {
    let appId = localStorage.getItem('appId') || 'wx9a373b1354d442cf'
    let infos_storage = getAppIdStorage(appId) || {}
    let url = response.request.responseURL

    if (!infos_storage?.url) {
      let newUrl = ''
      if (process.env.NODE_ENV === 'development') {
        newUrl = url.substring(0, url.indexOf('/api'))
      } else {
        newUrl = url.substring(0, url.indexOf('/pro'))
      }
      infos_storage.url = newUrl
      setAppIdStorage(appId, infos_storage)
    }

    const status = response.data.code
    const responseStatus = response.data.status

    if (status === 10021) {
      //根据运行环境跳转，重新获取ticket
      let environment = localStorage.getItem('environment')
      if (environment == 'weixin' && infos_storage.c !== 'h5') {
        //小程序内的H5
        let url = ''
        let params = '?getWuyeCode=' + 1 + '&returnPath=index'
        if (appId === 'wx51103d007a84d074') {
          url = '/advertPages/web-view/web-view'
        } else if (appId === 'wx0a797a7d1b13c050') {
          url = '/pages/cardlan-code/pay-status/pay-status' + params
        } else {
          url = '/pages/webview/webview'
        }
        wx.miniProgram.navigateTo({
          url: url,
        })
      } else if (environment === 'wxBrowser' || this.infos_storage.c === 'h5') {
        //获取公共ticket
        const RES = await getTicketApi()
        if (RES.data.code == 200) {
          let ticket = RES.data.data.ticket
          infos_storage.Ticket = ticket
          setAppIdStorage(appId, infos_storage)

          //解决在index页面当ticket过期时,获取到新ticket之后，执行router.go(0)刷新页面，此时url中的ticket还是过期的ticket,导致页面循环刷新
          //解决方法：把url、mercode参数传给获取个人ticket的接口，让服务器重新请求微信，实现重新登录
          if (window.location.href.indexOf('ticket') > 0) {
            let url = infos_storage.url + '/index'
            let params = {
              url,
              mercode: infos_storage.mercode,
              isUserInfo: false,
            }
            const RES1 = await getUserTicketApi(params)
            window.location.href = RES1.data.data.redirect_url
          } else {
            //ticket不存在或者过期重新刷新页面，接口重新请求
            nextTick(() => {
              router.go(0)
            })
          }
        } else {
          Toast('网络异常，请稍后再试')
        }
      }
    }

    if (responseStatus === 605) {
      //当前用户不存在或无权限
      Toast('当前用户没权限')
      return Promise.reject(new Error('用户无权限'))
    }
    return response
  },
  (error) => {
    return Promise.reject(error)
  }
)
export default axios
